import { Button } from '../../Utility/Button';
import { Globe, PencilSimple, Trash } from '@phosphor-icons/react';
import AdminContainer from '../../Utility/AdminContainer';
import usePrompts from '../../../Hooks/usePrompts';
import AdminBox from '../../Utility/AdminBox';
import AdminViewHeader from '../../Utility/AdminViewHeader';
import { PaginationWrapper } from '../../Utility/PaginationWrapper';
import { PaginationListType } from '../../../Types/PaginationParams';
import { promptService } from '../../../Services/promptService';
import { Prompt } from '../../../Types';
import AdminViewContent from '../../Utility/AdminViewContent';
import RadioButton from '../../Utility/FormElements/Radiobutton';
import useGlobals from '../../../Hooks/useGlobals';
import useSearchFilter from '../../../Hooks/useSearchFilter';
import SearchFilter from '../../Utility/SearchFilter';

function Prompts() {
    const { settings, userSettings } = useGlobals();
    const { PromptsActions, handleNavigate, i18n, basePromptIdentifier, prompts, windowWidth, getBreakpoint } =
        usePrompts();

    const { query, localQuery, searchActions } = useSearchFilter({
        initialQuery: null,
    });

    const GRID_COLS = 'grid-cols-[minmax(270px,490px),minmax(80px,150px),minmax(157px,1fr)]';

    return (
        <div className={`admin-container flex relative flex-col`}>
            <AdminContainer>
                <AdminBox classString="px-4">
                    <SearchFilter
                        value={localQuery}
                        onChange={searchActions.setLocalQuery}
                        onApply={searchActions.applyQuery}
                        onClear={searchActions.clearQuery}
                    />
                    <div className="mb-4 md:hidden w-full">
                        {(!settings.demo || userSettings.isSuperAdmin) && (
                            <Button
                                className="!m-0 !mb-3 flex justify-center items-center w-full"
                                onClick={() => handleNavigate('new')}
                            >
                                {i18n.translate({
                                    id: 'newAssistant.button',
                                    sourceName: 'Prompts',
                                })}
                            </Button>
                        )}
                    </div>
                    <div className="hidden md:block">
                        <div className="hidden md:block">
                            <AdminViewHeader
                                gridCols={GRID_COLS}
                                cols={{
                                    cols: [
                                        {
                                            text: i18n.translate({
                                                id: 'adminHeader.mainCol',
                                                sourceName: 'Main',
                                            }),
                                        },
                                        {
                                            text: i18n.translate({
                                                id: 'assistant.basic',
                                                sourceName: 'Prompts',
                                            }),
                                        },
                                    ],
                                    button:
                                        !settings.demo || userSettings.isSuperAdmin
                                            ? {
                                                  text: i18n.translate({
                                                      id: 'newAssistant.button',
                                                      sourceName: 'Prompts',
                                                  }),
                                                  function: () => handleNavigate('new'),
                                              }
                                            : undefined,
                                }}
                            />
                            <hr className="border-layout-borderColor mt-5" />
                        </div>
                    </div>

                    <PaginationWrapper
                        listType={PaginationListType.Assistants}
                        itemsFunction={promptService.getPromptsByPage}
                        itemsPerPage={15}
                        query={query || null}
                        renderItem={(prompt: Prompt, index: number) => (
                            <AdminViewContent
                                key={prompt.identifier}
                                mobile={windowWidth < getBreakpoint('md')}
                                identifier={prompt.identifier}
                                gridCols={GRID_COLS}
                                cols={{
                                    optionalCols: [
                                        {
                                            content: prompt.name ?? '',
                                            image: prompt.image,
                                            showImage: true,
                                        },
                                        {
                                            content: !prompt.isUserPrompt && (
                                                <RadioButton
                                                    key={prompt.identifier}
                                                    value={prompt.identifier}
                                                    name="base"
                                                    checked={prompt.isBasePrompt}
                                                    onChange={() =>
                                                        PromptsActions.handleOpenConfirmDialogBasePromptChange(
                                                            prompt.identifier,
                                                        )
                                                    }
                                                    label={windowWidth < getBreakpoint('md') ? 'Basis-Assistent' : ''}
                                                    className={windowWidth < getBreakpoint('md') ? 'mt-3' : ''}
                                                />
                                            ),
                                        },
                                    ],
                                    button: {
                                        buttons: [
                                            {
                                                variant: 'primaryRound',
                                                onClick: () => handleNavigate(prompt.identifier),
                                                icon: <PencilSimple />,
                                            },
                                            {
                                                variant: 'primaryRound',
                                                onClick: () => PromptsActions.handleMakeGlobal(prompt.identifier),
                                                icon: <Globe />,
                                                hideElement: !prompt.isUserPrompt,
                                                tooltipText: i18n.translate({
                                                    id: 'tooltip.makeGlobal',
                                                    sourceName: 'Prompts',
                                                }),
                                            },
                                            {
                                                variant: 'secondaryRound',
                                                onClick: () =>
                                                    PromptsActions.handleOpenConfirmDialog(prompt.identifier),
                                                icon: <Trash />,
                                                hideElement: prompt.isUserPrompt,
                                            },
                                        ],
                                    },
                                }}
                            />
                        )}
                    />
                </AdminBox>
            </AdminContainer>
        </div>
    );
}

export default Prompts;
